<template>
    <div>
        <div v-if="done">
            <b-container fluid>
                <b-form @submit="onSubmit">

                    <input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
                    <b-form-group label="guid">
                        <b-form-input type="text" id="dataItem-guid-input" class="form-input" v-model="dataItem.guid"
                            @blur="$v.dataItem.guid.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.guid.required">guid is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="companyId">
                        <b-form-input type="text" id="dataItem-companyId-input" class="form-input"
                            v-model="dataItem.companyId" @blur="$v.dataItem.companyId.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.companyId.required">companyId is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="number">
                        <b-form-input type="text" id="dataItem-number-input" class="form-input"
                            v-model="dataItem.number" @blur="$v.dataItem.number.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.number.required">number is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="name">
                        <b-form-input type="text" id="dataItem-name-input" class="form-input" v-model="dataItem.name"
                            @blur="$v.dataItem.name.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.name.required">name is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="isPrimary">
                        <b-form-input type="text" id="dataItem-isPrimary-input" class="form-input"
                            v-model="dataItem.isPrimary" @blur="$v.dataItem.isPrimary.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.isPrimary.required">isPrimary is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="physicalAddress1">
                        <b-form-input type="text" id="dataItem-physicalAddress1-input" class="form-input"
                            v-model="dataItem.physicalAddress1" @blur="$v.dataItem.physicalAddress1.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.physicalAddress1.required">physicalAddress1 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="physicalAddress2">
                        <b-form-input type="text" id="dataItem-physicalAddress2-input" class="form-input"
                            v-model="dataItem.physicalAddress2" @blur="$v.dataItem.physicalAddress2.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.physicalAddress2.required">physicalAddress2 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="physicalCity">
                        <b-form-input type="text" id="dataItem-physicalCity-input" class="form-input"
                            v-model="dataItem.physicalCity" @blur="$v.dataItem.physicalCity.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.physicalCity.required">physicalCity is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="physicalState">
                        <b-form-input type="text" id="dataItem-physicalState-input" class="form-input"
                            v-model="dataItem.physicalState" @blur="$v.dataItem.physicalState.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.physicalState.required">physicalState is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="physicalZipcode">
                        <b-form-input type="text" id="dataItem-physicalZipcode-input" class="form-input"
                            v-model="dataItem.physicalZipcode" @blur="$v.dataItem.physicalZipcode.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.physicalZipcode.required">physicalZipcode is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="mailingAddress1">
                        <b-form-input type="text" id="dataItem-mailingAddress1-input" class="form-input"
                            v-model="dataItem.mailingAddress1" @blur="$v.dataItem.mailingAddress1.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.mailingAddress1.required">mailingAddress1 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="mailingAddress2">
                        <b-form-input type="text" id="dataItem-mailingAddress2-input" class="form-input"
                            v-model="dataItem.mailingAddress2" @blur="$v.dataItem.mailingAddress2.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.mailingAddress2.required">mailingAddress2 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="mailingCity">
                        <b-form-input type="text" id="dataItem-mailingCity-input" class="form-input"
                            v-model="dataItem.mailingCity" @blur="$v.dataItem.mailingCity.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.mailingCity.required">mailingCity is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="mailingState">
                        <b-form-input type="text" id="dataItem-mailingState-input" class="form-input"
                            v-model="dataItem.mailingState" @blur="$v.dataItem.mailingState.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.mailingState.required">mailingState is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="mailingZipcode">
                        <b-form-input type="text" id="dataItem-mailingZipcode-input" class="form-input"
                            v-model="dataItem.mailingZipcode" @blur="$v.dataItem.mailingZipcode.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.mailingZipcode.required">mailingZipcode is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="shippingAddress1">
                        <b-form-input type="text" id="dataItem-shippingAddress1-input" class="form-input"
                            v-model="dataItem.shippingAddress1" @blur="$v.dataItem.shippingAddress1.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.shippingAddress1.required">shippingAddress1 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="shippingAddress2">
                        <b-form-input type="text" id="dataItem-shippingAddress2-input" class="form-input"
                            v-model="dataItem.shippingAddress2" @blur="$v.dataItem.shippingAddress2.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.shippingAddress2.required">shippingAddress2 is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="shippingCity">
                        <b-form-input type="text" id="dataItem-shippingCity-input" class="form-input"
                            v-model="dataItem.shippingCity" @blur="$v.dataItem.shippingCity.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.shippingCity.required">shippingCity is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="shippingState">
                        <b-form-input type="text" id="dataItem-shippingState-input" class="form-input"
                            v-model="dataItem.shippingState" @blur="$v.dataItem.shippingState.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.shippingState.required">shippingState is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="shippingZipcode">
                        <b-form-input type="text" id="dataItem-shippingZipcode-input" class="form-input"
                            v-model="dataItem.shippingZipcode" @blur="$v.dataItem.shippingZipcode.$touch()">
                        </b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.shippingZipcode.required">shippingZipcode is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="email">
                        <b-form-input type="text" id="dataItem-email-input" class="form-input" v-model="dataItem.email"
                            @blur="$v.dataItem.email.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.email.required">email is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="phone">
                        <b-form-input type="text" id="dataItem-phone-input" class="form-input" v-model="dataItem.phone"
                            @blur="$v.dataItem.phone.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.phone.required">phone is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="fax">
                        <b-form-input type="text" id="dataItem-fax-input" class="form-input" v-model="dataItem.fax"
                            @blur="$v.dataItem.fax.$touch()"></b-form-input>
                        <div class="invalid-feedback">
                            <div v-if="!$v.dataItem.fax.required">fax is required</div>
                        </div>
                    </b-form-group>
                    <b-form-group label="active">
                        <b-form-checkbox id="dataItem-active-input" class="form-input" v-model="dataItem.active">active
                        </b-form-checkbox>
                    </b-form-group>


                    <b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
                    <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
                </b-form>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import service from '../../service';
    import { dataItemDto } from '../../dto';

    export default {
        name: 'edit',
        data: () => ({
            done: false,
            dataItem: null
        }),
        computed: {
            id() {
                return this.$route.params.id;
            }
        },
        methods: {
            getRecord() {
                this.done = false;
                service.getById(this.id).then(data => {
                    this.dataItem = data;
                    this.done = true;
                });
            },
            async onSubmit(e) {
                e.preventDefault();

                this.$v.dataItem.$touch();
                if (this.$v.dataItem.$invalid) {
                    return;
                }

                let payload = new dataItemDto(this.dataItem);

                try {
                    const id = await service.update(payload);
                    this.redirectToListing();
                } catch { }
            },
            cancel() {
                this.redirectToListing();
            },
            redirectToListing() {
                this.$router.push({ name: 'companylocations' });
            }
        },
        mounted() {
            this.getRecord(this.id);
        },
        validations: {
            dataItem: {

                id: {
                },
                guid: {
                },
                companyId: {
                },
                number: {
                },
                name: {
                },
                isPrimary: {
                },
                physicalAddress1: {
                },
                physicalAddress2: {
                },
                physicalCity: {
                },
                physicalState: {
                },
                physicalZipcode: {
                },
                mailingAddress1: {
                },
                mailingAddress2: {
                },
                mailingCity: {
                },
                mailingState: {
                },
                mailingZipcode: {
                },
                shippingAddress1: {
                },
                shippingAddress2: {
                },
                shippingCity: {
                },
                shippingState: {
                },
                shippingZipcode: {
                },
                email: {
                },
                phone: {
                },
                fax: {
                },
                createdByUserId: {
                },
                modifiedByUserId: {
                },
                dateCreated: {
                },
                dateModified: {
                },
                active: {
                },
            }
        }
    }
</script>